import { findPostPurchaseCheckout } from 'lib/checkout/checkoutUtils'
import getIsCurrentRegionUserLoyaltyRegion from 'loyalty/selectors/getIsCurrentRegionUserLoyaltyRegion'
import { createSelector } from 'reselect'

const getCanRedeemInsuranceLoyaltyBenefit = createSelector(
  (state: App.State) => state.loyalty.account.data?.benefits,
  (state: App.State) => findPostPurchaseCheckout(state.checkout.cart.mode),
  (state: App.State) => getIsCurrentRegionUserLoyaltyRegion(state),
  (userBenefits, isPostPurchase, isCurrentRegionUserLoyaltyRegion): boolean => {
    if (!isCurrentRegionUserLoyaltyRegion) return false
    const insuranceBenefit = userBenefits?.find(benefit => benefit.code === 'discounted_insurance')
    return !isPostPurchase && !!insuranceBenefit && (insuranceBenefit.unlimited || !!insuranceBenefit.remaining)
  },
)

export default getCanRedeemInsuranceLoyaltyBenefit
